import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5c-5.457 0 -10 3.028 -10 7s4.543 7 10 7s10 -3.028 10 -7s-4.543 -7 -10 -7z","key":"svg-0"}]]

const IconOvalVerticalFilled = createReactComponent('filled', 'oval-vertical-filled', 'OvalVerticalFilled', __iconNode);

export default IconOvalVerticalFilled;